import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import { slideFragment } from '@schema/slide'
import MemberEventsLanding from '@layouts/member-events-landing/index'
import { AMATEUR_FEATURED_STORIES_QUERY } from './amateur-programs-landing-fragment'

const QUERY = gql`
query AmatuerEventsLandingPage($preview: Boolean)  {
  amateurEventsLandingCollection(limit: 1, preview: $preview)  {
    items {
      headline
      heroImage {
        url
      }
      featuredEvent {
        __typename
				headline
        startDate
        endDate
        slug
        image {
          url
        }
      }
      eventCategoriesCollection {
        total
        items {
          sys {
            id
          }
          title
          name
        }
      }
      ctaBoxesCollection(limit: 2) {
        items {
          ${slideFragment}
        }
      }
      metaTitle
      metaDescription
      metaImage {
        url
      }
    }
  }
}
`

export default function AmateurProgramsLandingWithData(props) {
  const { query } = props
  return (
    <Query query={QUERY} variables={query}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} displayErrorType="page" />
        if (loading) return <LinearProgress color="secondary" />

        const response = data.amateurEventsLandingCollection && data.amateurEventsLandingCollection.items[0]

        return response ? (
          <MemberEventsLanding
            eventGridHeadline="Amateur Programs"
            parentCollection="amateurEventsLandingCollection"
            featuredStoriesQuery={AMATEUR_FEATURED_STORIES_QUERY}
            {...response}
            {...props}
          />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

AmateurProgramsLandingWithData.propTypes = {
  query: PropTypes.object,
}
